import useStores from 'shared/hooks/use-stores';
import { useDutchiePay } from 'src/payments/hooks/use-dutchie-pay/use-dutchie-pay';
import { useIncentives } from 'src/payments/hooks/use-incentives/use-incentives';
import { usePayByBankPointsBoost } from 'src/payments/hooks/use-pay-by-bank-points-boost';
import { usePointsBoostSurfacesConfig } from 'src/payments/hooks/use-points-boost-surfaces-config';

export type PointsBoostCheckoutTreatment = {
  showTreatment: boolean;
  // Display label from the points-boost foundation (e.g. "2x", "2.5x"); never a dollar amount.
  pointsBoostLabel: string | null;
};

// Checkout-surface gate for Points Boost. The surfaces-config leaf fails closed (defaults
// false) and the config query is skipped unless the surface is on and PBB is offered for the
// dispensary. Cash first: whenever any cash-back/signup-discount incentive is eligible
// (showPaymentBanner), points suppresses so at most one reward is visible on the page.
export const usePointsBoostCheckoutTreatment = (): PointsBoostCheckoutTreatment => {
  const { checkout: surfaceEnabled } = usePointsBoostSurfacesConfig();
  const { isDutchiePayEnabledForDispo } = useDutchiePay();
  const { showPaymentBanner } = useIncentives();
  const { Cart } = useStores();

  const enabled = surfaceEnabled && isDutchiePayEnabledForDispo;
  const { status, multiplierLabel } = usePayByBankPointsBoost({
    dispensaryId: Cart.order?.dispensary?.id,
    enabled,
  });

  const showTreatment = !showPaymentBanner && enabled && status === 'available' && multiplierLabel !== null;

  return {
    showTreatment,
    pointsBoostLabel: showTreatment ? multiplierLabel : null,
  };
};
